var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"questions",attrs:{"id":"questionFrame"}},[_c('image-horizontal',{staticClass:"questions__image",attrs:{"id":"questionContent"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }